export const updateQuestionAnswers = (questions) => ({
  type: "UPDATE_QUESTIONS_ANSWERS",
  payload: questions
});



// WEBPACK FOOTER //
// ./src/actions/verificationAction.js